var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"qrcode-margin-controller"},[_c('div',{staticClass:"round_top"},[_c('ul',{staticClass:"textedit"},[_c('li',{staticClass:"btn btn100 gray",on:{"click":_vm.changeMargin}},[_c('div',[_vm._v(_vm._s(_vm.marginText))])])])])])}
var staticRenderFns = []

export { render, staticRenderFns }